import {priority, wcfclient} from '@priority-software/priority-proto-api/lib';
import {getAdditionalProps} from '../../services/proto/core/loginProps';
import {callServer, Options} from '../../services/proto/core/server';
import {ServerMethods} from '../../services/proto/core/constants';

export const approveWarning = async (
    Session: string,
    options?: Partial<Options>
): Promise<priority.netitems.form.WarningApproveRs> => {
    return callServer(
        wcfclient.warningApprove,
        new priority.netitems.form.WarningApproveRq({
            Properties: getAdditionalProps(),
            Session
        }),
        ServerMethods.WarningApproveRq,
        options
    );
};
